import { render, staticRenderFns } from "./GroupFieldSelectValue.vue?vue&type=template&id=71d24c84&scoped=true"
import script from "./GroupFieldSelectValue.vue?vue&type=script&lang=js"
export * from "./GroupFieldSelectValue.vue?vue&type=script&lang=js"
import style0 from "./GroupFieldSelectValue.vue?vue&type=style&index=0&id=71d24c84&prod&lang=less"
import style1 from "./GroupFieldSelectValue.vue?vue&type=style&index=1&id=71d24c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d24c84",
  null
  
)

export default component.exports